const dataPierwszejRejestracji = { t: 'Data pierwszej rejestracji', name: 'data-pierwszej-rejestracji' }
export default dataPierwszejRejestracji